import { Maintenance } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

interface MaintenanceResponse extends DefaultResponse<Maintenance, true> {}
interface MaintenanceSingleResponse extends DefaultResponse<
  Maintenance,
  false
> {}

interface VehicleMaintenanceRequest {
  vehicle_id: number;
  description: string;
  provider_id: number | null;
  odometer?: number | null;
  value: number | null;
  type?: "odometer" | "date" | "both";
  date?: string | null;
  occurrence_date?: string | null;
  invoice?: string | null;
  client_provider_id?: number | null;
  notification_date_15?: boolean | number;
  notification_date_30?: boolean | number;
  notification_odometer_1000?: boolean | number;
  notification_odometer_2500?: boolean | number;
  notification_odometer_5000?: boolean | number;
  is_recurring?: boolean;
  interval_km?: number | null;
  interval_months?: number | null;
}

export const maintenanceService = {
  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<MaintenanceResponse>(
      "/vehicle_maintenance",
      {
        params: {
          page,
          per_page,
          search,
          ...filters,
        },
      },
    );
    return response.data;
  },

  async show(id: number) {
    const response = await api.get<MaintenanceSingleResponse>(
      `/vehicle_maintenance/${id}`,
    );
    return response.data;
  },

  async store(data: VehicleMaintenanceRequest) {
    const response = await api.post<MaintenanceSingleResponse>(
      "/vehicle_maintenance",
      data,
    );
    return response.data;
  },

  async update(id: number | string, data: VehicleMaintenanceRequest) {
    const response = await api.put<MaintenanceSingleResponse>(
      `/vehicle_maintenance/${id}`,
      data,
    );
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete<DefaultResponse<never>>(
      `/vehicle_maintenance/${id}`,
    );
    return response.data;
  },
};
